<app-monitor-layout #monitorContainer
  [test]="test"
  [testLoading]="testLoading$ | async"
  [patient]="patient"
  [bundle]="bundle"
  [screen]="currentDeviceScreen"
  [isTestDone]="isTestDone"
  [isTestSyncing]="isTestSyncing"
  [deviceLoading]="deviceLoading$ | async"
  [device]="device"
  [batteryPercentage]="batteryPercentage"
  [streamPopupVisible]="streamPopupVisible"
  [isSingleImage]="isSingleImage"
  [isV2Streaming]="isV2Streaming"
  [deviceActionLoading]="deviceActionLoading"
  [isLoading]="isLoading"
  [headsetAlignment]="headsetAlignment"
  (onClose)="close()"
  (onStreamOpen)="openStream($event)"
  (onStreamClose)="closeStream()"
  (onActionClicked)="onActionClicked($event)">

  <div
    class="monitor_container-column"
    [ngClass]="{'monitor_container-column--single': !isPartOfSensorimotorSuite}"
    (window:resize)="windowChanged.emit(getEvent())">

    <div
      class="monitor_graph-box"
      [ngClass]="{'monitor_graph-box--single': !isPartOfSensorimotorSuite}">

      @if (isTestSyncing) {
        <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
      }
      @if (state?.eye && !isTestDone) {
        <div class="monitor_eye-box">
          <div><i class="fas fa-eye fa-4x text--blink"></i></div>
          <br>
            <span>{{ 'currentlyTesting' | translate | titlecase }}: {{ state.eye }}</span>
            @if (!isPartOfSensorimotorSuite) {
              @switch (state.phase) {
                @case (0) {
                  <div>{{ 'phase' | translate | titlecase }}: {{ 'coverUncover' | translate }}</div>
                }
                @case (1) {
                  <div>{{ 'phase' | translate | titlecase }}: {{ 'coverAlternate' | translate }}</div>
                }
              }
            }
            @if (testingPositions) {
              <div>{{ 'testingPositions' | translate | titlecase }}: {{ testingPositions | translate }}</div>
            }
          </div>
        }
      </div>

      <div [hidden]="!isPartOfSensorimotorSuite" class="monitor_graph-box" #plotContainer>
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }

        @if (layout) {
          <plotly-plot [data]="plotData" [layout]="layout" [config]="monitorTestService.plotOptions"
            [revision]="count" [debug]="true" class="monitor_plot-box">
          </plotly-plot>
        }
      </div>
    </div>

    <div class="monitor_container-column monitor_container-column--single">
      <div class="monitor_graph-box monitor_graph-box--single">
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        @if (state) {
          <app-percentage-circle
            id="test-percentage"
            class="monitor_circle-box"
            [percentage]="state.progress">
          </app-percentage-circle>
        }
      </div>
    </div>
  </app-monitor-layout>
